import { AirLock, Equipment, EquipmentType, Extractor, sitesEacm } from "@/models/equipment.model";
import { ElementaryZone } from "@/models/site.model";
import store from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";
import EquipmentSelector from "./parts/EquipmentSelector/index.vue";
import EquipmentDetails from "./parts/EquipmentDetails/index.vue";
import {
  UPDATE_AIRLOCK_IN_ZONE,
  UPDATE_EACM_EQUIPMENT,
  UPDATE_EAR_EQUIPMENT,
  UPDATE_MANDATORY_EXTRACTOR_AND_STATUS,
  UPDATE_MANDATORY_EXTRACTOR_COUNT,
  UPDATE_OPTIONAL_EXTRACTOR,
  UPDATE_OPTIONAL_EXTRACTOR_COUNT,
  UPDATE_OPTIONAL_EACM_SITES,
  UPDATE_OPTIONAL_EACM_EQUIPMENT, /*Evolution majeure de EACM */

} from "@/store/operators";
import useVuelidate from "@vuelidate/core";
import { computed, Ref, ref, watch } from "@vue/composition-api";
import { minValue, required, requiredIf } from "@vuelidate/validators";
import Multiselect from "vue-multiselect"; /*Evolution majeure de EACM */
import "vue-multiselect/dist/vue-multiselect.min.css"; /*Evolution majeure de EACM */

/**
 * This component display the selected equipment
 * Since the 5 categories have a different behavior this component will use prop dependant behavior to reflect this.
 */
@Component({
  components: {
    EquipmentSelector,
    EquipmentDetails,
    Multiselect, /*Evolution majeure de EACM */
  },
  setup(props: any) {
    //we init datas in setup and then create a reactive object with composition api. Needed in order to use vuelidate.
    const selectorVisible = ref(false);
    const defaultEquipmentName = "defaultEquipment";
    const equipment: Ref<AirLock | Extractor | Equipment | null> = ref(null);
    let listSitesOptional: ElementaryZone[]= [];

    //There are 2 fields in store. We determine the one to use ased on the mandatory prop.
    const extractorsCount = ref(
      props.isMandatory
        ? store.state.equipmentsModule.mandatoryExtractorCount
        : store.state.equipmentsModule.optionalExtractorCount
    );

    /*listSitesEacm Evolution majeure de Eacm */ 
    const listSites = ref(
      (store.state.equipmentsModule.optionalEacmEquipment &&  store.state.equipmentsModule.optionalEacmsites)?
      store.state.equipmentsModule.optionalEacmsites:
      []
    );

    /**
     * Init the data depending on the equipmentType. Replace created lifecycle Hook in setup
     */
    switch (props.equipmentType) {
      case EquipmentType.workersAirLock:
        equipment.value = props.zone.personnelEquipment;
        break;
      case EquipmentType.wastesAirLock:
        equipment.value = props.zone.wasteEquipment;
        break;
      case EquipmentType.extractor:
        equipment.value = props.zone.customEquipment;
        break;
      case EquipmentType.eacm:
        equipment.value = props.zone.customEquipment;
        break;
      case EquipmentType.ear:
        equipment.value = props.zone.customEquipment;
        break;
    }

    //Invert selectorVisible boolean. Used in template to display either selector or details component
    function toggleVisible(): void {
      selectorVisible.value = !selectorVisible.value;
    }

    function deleteEquipment(): void {
      assignEquipment(null);
    }

    /**
     * return true when equipment is defined and is different than the defaultEquipment we set at initialization.
     */
    function isEquipmentSelected(): boolean {
      return !!equipment.value?.id && equipment.value?.id !== defaultEquipmentName;
    }

    /**
     * Depending on the equipmentType we store equipments in differents module of the vuex store.
     * Airlocks are store in their associated zone in site module.
     * Others equipments type are saved in their individuals fields in equipment module.
     * @param equipmentParameter Assign equipment to the right field in store depending on the equipmentType
     */
    function assignEquipment(equipmentParameter: AirLock | Extractor | Equipment | null): void {
      equipment.value = equipmentParameter;
      switch (props.equipmentType) {
        case EquipmentType.workersAirLock:
        case EquipmentType.wastesAirLock:
          store.commit(UPDATE_AIRLOCK_IN_ZONE, {
            zone: props.zone,
            equipmentType: props.equipmentType,
            airlock: equipment.value,
          });
          break;
        case EquipmentType.extractor:
          if (props.isMandatory) {
            store.dispatch(UPDATE_MANDATORY_EXTRACTOR_AND_STATUS, equipment.value);
          } else {
            store.commit(UPDATE_OPTIONAL_EXTRACTOR, equipment.value);
          }
          break;
        case EquipmentType.eacm:
          if(isEacmOptional() ==true) {
            store.commit(UPDATE_OPTIONAL_EACM_EQUIPMENT, equipment.value);
          } else {
            store.commit(UPDATE_EACM_EQUIPMENT, equipment.value);

          }
          break;
        case EquipmentType.ear:
          store.commit(UPDATE_EAR_EQUIPMENT, equipment.value);
          break;
      }
      if (equipmentParameter) {
        toggleVisible();
      }
    }

    function isExtractor(): boolean {
      return props.equipmentType === EquipmentType.extractor;
    }

      /* Evolution majeure de EACM */
    function isEacmOptional(): boolean {
      return props.equipmentType === EquipmentType.eacm && props.zone.name == "eacm optional" ;
    }

    //Watchers
    //Update extractorCount in store when it's modified. We use a watcher because of composition api
    function setExtractorsCount(newCount: number) {
      newCount = newCount < 0 ? 0 : newCount;
      if (props.isMandatory) {
        store.commit(UPDATE_MANDATORY_EXTRACTOR_COUNT, newCount);
      } else {
        store.commit(UPDATE_OPTIONAL_EXTRACTOR_COUNT, newCount);
      }
    }

    watch(extractorsCount, setExtractorsCount);

    /* Evolution majeure de EACM */
    function setListZonesEacm(newList: ElementaryZone[]) {
        /**Faire une vérification de la liste des sites de léquipement
         * Si newList.length== eacmListSites.length
         * Alors retirer le newTag de la liste
         */ 
      const eacmListSites = store.getters.GET_ALL_ELEMENTARY_ZONES;
      if(newList.length === eacmListSites.length) newList.pop();
      store.commit(UPDATE_OPTIONAL_EACM_SITES, newList);
      

      listSitesOptional = store.state.equipmentsModule.optionalEacmsites;
    }
    watch(listSites, setListZonesEacm); /*Evolution majeure de EACM */


    //Validations rules

    const rules: any = {
      equipment: {
        //If we don't use a function in requiredIf, then the props never update
        requiredIfMandatory: requiredIf(() => props.isMandatory),
       // requiredIfOptionalEacm: requiredIf(() => isExistoptionalEacmEquipment),
      },
    };
    if (isExtractor() && props.isMandatory) {
      rules.extractorsCount = {
        required,
        minimum: minValue(1),
      };
    } else {
      rules.extractorsCount = true;
    }

    /*Evolution majeure de Eacm */ 
    // if (isExistoptionalEacmEquipment) {
    //   rules.listSites = {
    //     required,
    //   };
    // } else {
    //   rules.listSites = true;
    // }

    return {
      //Validations
      v: useVuelidate(rules, { equipment, extractorsCount, listSites}),
      //Datas
      selectorVisible,
      equipment,
      extractorsCount,
      listSites, /*Evolution majeure de Eacm */ 
      //Computed
      isEquipmentSelected: computed(isEquipmentSelected),
      isExtractor: computed(isExtractor),
      isEacmOptional: computed(isEacmOptional), /*Evolution majeure de EACM*/
      //Methods
      assignEquipment: assignEquipment,
      toggleVisible: toggleVisible,
      deleteEquipment,
    };
  },
})
export default class EquipmentDisplay extends Vue {
  @Prop() zone!: ElementaryZone;
  @Prop() equipmentType!: EquipmentType;
  @Prop({ default: true }) isMandatory!: boolean;
  @Prop() categoryTitle!: string;

  collapseId = "selector_" + this.zone.name + "_" + this.equipmentType;
  title = "";

  /**
   * Init the title depending on the equipmentType. Duplicate of switch case in setup because we can't use i18n in setup
   */
  created(): void {
    switch (this.equipmentType) {
      case EquipmentType.wastesAirLock:
      case EquipmentType.workersAirLock:
        this.title = this.zone.name;
        break;
      case EquipmentType.extractor:
        this.title = this.$t("components.equipmentPage.extractorModel").toString();
        break;
      case EquipmentType.eacm:
        this.title = this.$t("components.equipmentPage.eacmModel").toString();
        break;
      case EquipmentType.ear:
        this.title = this.$t("components.equipmentPage.earModel").toString();
        break;
    }
  }

  get isPhone(): boolean {
    return !this.$screen.md;
  }

  /*Evolution majeure de EACM*/
  get maxOptionalZones(): number {
    return Math.max(this.eacmListSites.length - 1, 1);
  }

  get eacmListSites(): ElementaryZone[]{
    const allZones = store.getters.GET_ALL_ELEMENTARY_ZONES
    store.state.equipmentsModule.mandatoryEacmSites;
    return store.getters.GET_ALL_ELEMENTARY_ZONES;
  } 
}
